import { render } from "./ChartSquareBarIcon.vue?vue&type=template&id=de4c514a"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__